'use client';

import { createStore } from 'zustand';

import { DifferentCityAnswer } from '@/types/different-city-confirmation.types';

export type DifferentCityConfirmationState = {
  isOpen: boolean;
};

const initialState: DifferentCityConfirmationState = {
  isOpen: false,
};

export const differentCityConfirmationStore = createStore<DifferentCityConfirmationState>(() => ({
  ...initialState,
}));

let pendingAnswer: ((answer: DifferentCityAnswer) => void) | null = null;

const answer = (given: DifferentCityAnswer) => {
  const respond = pendingAnswer;

  pendingAnswer = null;
  differentCityConfirmationStore.setState({ ...initialState });
  respond?.(given);
};

export const openDifferentCityConfirmation = (): Promise<DifferentCityAnswer> => {
  answer('dropped');

  return new Promise<DifferentCityAnswer>((resolve) => {
    pendingAnswer = resolve;
    differentCityConfirmationStore.setState({ isOpen: true });
  });
};

export const acceptDifferentCityConfirmation = () => answer('accepted');

export const cancelDifferentCityConfirmation = () => answer('cancelled');

export const dropDifferentCityConfirmation = () => answer('dropped');
